import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useSteps } from '../../hooks/use-steps.js';
import { ConfiguratorMain } from './ConfiguratorMain.js';

const ConfiguratorMainContainer = (props)=>{
    const { currentStepName  } = useSteps();
    return /*#__PURE__*/ React__default.createElement(ConfiguratorMain, swcHelpers.extends({
        currentStepName: currentStepName
    }, props));
};

export { ConfiguratorMainContainer };
//# sourceMappingURL=ConfiguratorMainContainer.js.map
